import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.career');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-career',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.career/view.scss */
:host {
  display: block;
}

@media (max-width: 768px) {
  section.relative {
    min-height: 300px;
  }
  section.relative h1 {
    font-size: 2rem;
  }
}`],
})
export class PageCareerComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public jobs: any[] = [];
    private observer: IntersectionObserver;

    public talents = [
        { index: '01', key: 'item-1', icon: 'icon-lightbulb' },
        { index: '02', key: 'item-2', icon: 'icon-award' },
        { index: '03', key: 'item-3', icon: 'icon-users' },
        { index: '04', key: 'item-4', icon: 'icon-puzzle' },
        { index: '05', key: 'item-5', icon: 'icon-rocket' },
        { index: '06', key: 'item-6', icon: 'icon-target' }
    ];

    public benefits = [
        { icon: 'icon-laptop', key: 'benefit_mac' },
        { icon: 'icon-package', key: 'benefit_software' },
        { icon: 'icon-clock', key: 'benefit_flex' },
        { icon: 'icon-calendar', key: 'benefit_vacation' },
        { icon: 'icon-utensils', key: 'benefit_dinner' },
        { icon: 'icon-coffee', key: 'benefit_snack' },
        { icon: 'icon-gift', key: 'benefit_holiday' },
        { icon: 'icon-heart', key: 'benefit_family' },
        { icon: 'icon-graduation-cap', key: 'benefit_education' },
        { icon: 'icon-book-open', key: 'benefit_book' },
        { icon: 'icon-shield', key: 'benefit_pension' },
        { icon: 'icon-shield-check', key: 'benefit_insurance' }
    ];

    public steps = [
        { step: 'Step 1', label: 'career.receipt', desc: 'career.step1', color: 'bg-white border-zinc-200' },
        { step: 'Step 2', label: 'career.submit', desc: 'career.step2', color: 'bg-zinc-100 border-zinc-300' },
        { step: 'Step 3', label: 'career.interview', desc: 'career.step3', color: 'bg-blue-600 border-blue-600 text-white' },
        { step: 'Step 4', label: 'career.confirmed', desc: 'career.step4', color: 'bg-zinc-900 border-zinc-900 text-white' }
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        this.initScrollAnimations();
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code === 200) this.jobs = data;
        await this.service.render();
    }

    public openJob(url: string) {
        window.open(url);
    }

    private initScrollAnimations() {
        if (typeof IntersectionObserver === 'undefined') return;
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                    this.observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.15 });

        setTimeout(() => {
            document.querySelectorAll('.scroll-reveal').forEach(el => this.observer.observe(el));
        }, 100);
    }

    ngOnDestroy() {
        if (this.observer) this.observer.disconnect();
    }
}

export default PageCareerComponent;